module.exports = __webpack_public_path__ + "static/media/jasmine_wongphatarakul.e2cf98c7.png";